import { Order, OrderStatus } from "types/orders";
import { getDifferenceBetweenDates, getUserFriendlyDate } from "utils/DateUtils";

const getPaymentNote = (order: Order) => {
  let payDeadline: { date: string; time: string };
  const createdAt = Date.parse(order.created_at);
  const payBefore = Date.parse(order.pay_before);
  const startAt = Date.parse(order.stream_start_time);

  if (getDifferenceBetweenDates(startAt, createdAt).days >= 1) {
    payDeadline = getUserFriendlyDate(payBefore);
  } else {
    payDeadline = getUserFriendlyDate(startAt - 300000);
  }

  return `The payment should be made before ${payDeadline.date} ${payDeadline.time}`;
};

export const ORDER_STATUS_MAP: (translate: any) => Record<OrderStatus, string> = (translate) => ({
  [OrderStatus.CREATED]: translate("orders.status.created"),
  [OrderStatus.CONFIRMED]: translate("orders.status.confirmed"),
  [OrderStatus.CHANGED]: translate("orders.status.changed"),
  [OrderStatus.ACCEPTED]: translate("orders.status.confirmed"),
  [OrderStatus.PAID_FOR]: translate("orders.status.paid_for"),
  [OrderStatus.STARTED]: translate("orders.status.paid_for"),
  [OrderStatus.COMPLETED]: translate("orders.status.completed"),
  [OrderStatus.PAID_OUT]: translate("orders.status.paid_out"),
  [OrderStatus.CANCELED]: translate("orders.status.canceled"),
  [OrderStatus.CONFIRMATION_EXPIRED]: translate("orders.status.canceled"),
  [OrderStatus.START_EXPIRED]: translate("orders.status.canceled"),
  [OrderStatus.PAYMENT_EXPIRED]: translate("orders.status.canceled"),
  [OrderStatus.REFUNDED]: translate("orders.status.refunded")
});

export const ORDER_STATUS_NOTES_MAP: Record<OrderStatus, (order: Order) => string> = {
  [OrderStatus.CREATED]: () => "Waiting 48 hrs for streamer's confirmation",
  [OrderStatus.CONFIRMED]: getPaymentNote,
  [OrderStatus.CHANGED]: () => "Waiting for streamer's confirmation",
  [OrderStatus.ACCEPTED]: getPaymentNote,
  [OrderStatus.PAID_FOR]: () => "",
  [OrderStatus.STARTED]: () => "",
  [OrderStatus.COMPLETED]: () => "",
  [OrderStatus.PAID_OUT]: () => "",
  [OrderStatus.CANCELED]: () => "",
  [OrderStatus.CONFIRMATION_EXPIRED]: () => "",
  [OrderStatus.START_EXPIRED]: () => "",
  [OrderStatus.PAYMENT_EXPIRED]: () => "",
  [OrderStatus.REFUNDED]: () => "",
};

export const MAX_ACTIVE_ORDERS_COUNT = 10;

export const MIN_STREAM_DURATION_IN_MINUTES = 15;
export const MIN_TIME_BEFORE_ASAP_ORDER_IN_MINUTES = 10;
export const MIN_TIME_BEFORE_SCHEDULED_ORDER_IN_MINUTES = 30;
export const FREE_CANCELLATION_TIME = 60000;
